import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";
import type { CollectionPostResponse } from "util/posts";

export interface UserCollection extends CollectionPostResponse {
  item_count: number;
  contains_entity: boolean;
  activity_at?: string | null;
}

export interface UserCollectionsResponse {
  collections: UserCollection[];
}

export interface CollectionItemsResponse {
  collection: UserCollection;
  items: Array<Record<string, unknown>>;
  item_relations?: Array<{
    relation_id: string;
    related_id: number;
    related_type: string;
    position: { x: number; y: number } | null;
    merged_from?: string;
  }>;
  sync?: { source_collection_id?: number; sync_enabled?: boolean } | null;
  total: number;
  limit: number;
  offset: number;
}

export const collectionApi = {
  getUserCollections: async (params?: {
    entityId?: number | null;
    entityType?: string | null;
    limit?: number;
    offset?: number;
  }): Promise<UserCollectionsResponse> => {
    const response = await api.get<UserCollectionsResponse>(apiRoutes.collections.root, { params });
    return response.data;
  },

  addItem: async (
    collectionId: number,
    payload: {
      entityId: number;
      entityType: string;
      properties?: Record<string, unknown> | null;
    }
  ): Promise<Record<string, unknown>> => {
    const response = await api.post<Record<string, unknown>>(
      apiRoutes.collections.items(collectionId),
      payload
    );
    return response.data;
  },

  removeItem: async (
    collectionId: number,
    entityType: string,
    entityId: number
  ): Promise<Record<string, unknown>> => {
    const response = await api.delete<Record<string, unknown>>(
      apiRoutes.collections.item(collectionId, entityType, entityId)
    );
    return response.data;
  },

  getItems: async (
    collectionId: number,
    params?: { limit?: number; offset?: number }
  ): Promise<CollectionItemsResponse> => {
    const response = await api.get<CollectionItemsResponse>(apiRoutes.collections.items(collectionId), {
      params,
    });
    return response.data;
  },

  patchItemPosition: async (
    collectionId: number,
    entityType: string,
    entityId: number,
    position: { x: number; y: number }
  ): Promise<{ relation: Record<string, unknown> }> => {
    const response = await api.patch<{ relation: Record<string, unknown> }>(
      apiRoutes.collections.itemPosition(collectionId, entityType, entityId),
      { position }
    );
    return response.data;
  },
};
